import setPurposesNegative from './set_purposes_negative';
import setPurposesPositive from './set_purposes_positive';
import checkForNegativePurpose from './check_for_negative_purpose';
import init from './init';

export default {
    setPurposesNegative,
    setPurposesPositive,
    checkForNegativePurpose,
    init,
};